import { FloatingDelayGroup } from '@floating-ui/react';
import { duration } from 'dayjs';
import React from 'react';

import { NeueTooltip } from 'src/editor/content-creation/components/tooltip';
import { DeleteRegularIcon, RefreshLightIcon } from 'src/monet/icons';
import { calculateTimeDuration } from 'src/record/helpers';
import { useRecordingStore } from './store';

interface RecordingControlButtonProps {
  tooltip: string;
  onClick?: () => void;
}

export const RecordingControlButton: React.FC<RecordingControlButtonProps> = ({
  tooltip,
  children,
  onClick,
}) => {
  return (
    <NeueTooltip offset={16} placement='top' tooltipContent={tooltip}>
      <div
        onClick={onClick}
        className={'rounded transition-colors text-neue-journey-fg p-1.5 cursor-pointer bg-transparent'}
      >
        {children}  
      </div>      
    </NeueTooltip>
  )
}

export const RecordingControls = () => {
  const {
    stopRecordingCamera,
    cancelRecordingCamera,
    restartRecordingCamera,
    durationElapsed,
    recording,
  } = 
  useRecordingStore((state: any) => ({
    stopRecordingCamera: state.stopRecordingCamera,
    cancelRecordingCamera: state.cancelRecordingCamera,
    restartRecordingCamera: state.restartRecordingCamera,
    durationElapsed: state.durationElapsed,
    recording: state.recording,
  }));

  if (!recording) return null;

  return (
    <div className='absolute z-neue-new-block-button-bar bottom-6 right-6 flex justify-center items-center pointer-events-none'>
      <FloatingDelayGroup delay={{ open: 500 }}>
        <div className='pointer-events-auto flex flex-row transition rounded-lg bg-neue-journey-bg text-neue-journey-fg gap-2 p-2 items-center'>
          <RecordingControlButton tooltip='Stop recording' onClick={stopRecordingCamera}>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="16" height="16" rx="2" fill="#FF5158"></rect>
            </svg>
          </RecordingControlButton>
          <div className="rounded p-1.5">
            <div className="text-bedrock-p text-neue-journey-fg min-w-[40px]">
              {durationElapsed ? calculateTimeDuration(durationElapsed) : '00:00'}
            </div>
          </div>
          <span className="w-[1px] h-8 bg-neue-journey-fg-50" />
          <RecordingControlButton tooltip='Restart recording' onClick={restartRecordingCamera}>
            <RefreshLightIcon />
          </RecordingControlButton>
          <RecordingControlButton tooltip='Cancel recording' onClick={cancelRecordingCamera}>
            <DeleteRegularIcon />
          </RecordingControlButton>
        </div>
      </FloatingDelayGroup>
    </div>
  )
}